import { render } from "./InfoPermis.view.vue?vue&type=template&id=57adbfd3"
import script from "./InfoPermis.view.vue?vue&type=script&lang=js"
export * from "./InfoPermis.view.vue?vue&type=script&lang=js"

import "./InfoPermis.view.vue?vue&type=style&index=0&id=57adbfd3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__